
import PrismicData from '~/assets/js/prismic-controller.js'
import BlogNavbar from '~/components/blog/BlogNavbar.vue'
import BlogShare from '~/components/blog/BlogShare.vue'
import BlogRelatedPosts from '~/components/blog/BlogRelatedPosts.vue'
export default {
  name: 'Post',
  components: {
    BlogNavbar,
    BlogShare,
    BlogRelatedPosts,
  },
  async asyncData({ $prismic, app, params, query, store, error, req }) {
    const lang = app.i18n.locales.filter((i) =>
      i.iso.includes(app.i18n.locale)
    )[0].iso
    try {
      const results = await $prismic.api.query(
        $prismic.predicates.at('my.post.uid', params.uid),
        { lang, fetchLinks: 'blog_category.name' }
      )
      const post = results.results[0]

      /* Alt Lang */
      function getAltLangNav(altLanguages) {
        const promises = altLanguages.map(async (item) => {
          const lang = item.lang.substr(0, 2)
          const results = await $prismic.api.query(
            $prismic.predicates.at('my.post.uid', item.uid),
            { lang: item.lang, fetch: ['post.category'] }
          )
          return {
            [lang]: {
              category: results.results[0].data.category.uid,
              uid: item.uid,
            },
          }
        })
        return Promise.all(promises)
      }
      if (post && post.alternate_languages.length) {
        const altLang = await getAltLangNav(post.alternate_languages)
        store.dispatch(
          'i18n/setRouteParams',
          altLang.reduce((a) => a)
        )
      }

      /* Related */
      const relatedPostsResponse = await $prismic.api.query(
        [
          $prismic.predicates.at('document.type', 'post'),
          $prismic.predicates.at('my.post.category', post.data.category.id)
        ],
        {
          lang,
          orderings: '[my.post.date desc]',
          pageSize: 4,
          page: 1,
          fetchLinks: 'blog_category.name',
        }
      )
      const relatedPosts = relatedPostsResponse.results

      return {
        document: post.data,
        slices: post.data.body,
        formattedDate: Intl.DateTimeFormat(lang, {
          year: 'numeric',
          month: 'long',
          day: '2-digit',
        }).format(new Date(post.data.date)),
        documentUid: post.uid,
        documentLang: post.lang.substr(0, 2),
        relatedPosts,
      }
    } catch (e) {
      error({ message:  JSON.stringify(e), statusCode: 404 })
    }
  },
  head() {
    return PrismicData.seo(this.$nuxtI18nHead({ addSeoAttributes: true }), 
      this.document,
      'blog/' + this.document.category.uid + '/' + this.documentUid,
      this.documentLang,
      this.documentUid
    )
  },
}
